// outer IIFE to make sure each shared component can define its own isNodeJs.
// isNodeJs is scoped to the outer IIFE this way
(function () {

  // tests available under server/test/translateHelper
  class TranslateHelpers {
    constructor ({
      labels,
      languageFn
    }) {
      // @ts-ignore
      this.labels = labels;
      // @ts-ignore
      this.languageFn = languageFn;
    }

    getLabelText (name, word = 'label', languageStr = 'nl', logger = () => {}) {
      // @ts-ignore
      const language = this.languageFn ? this.languageFn() : languageStr;
      // @ts-ignore
      if (!this.labels) {
        // @ts-ignore
        logger('labels have not been loaded');
        return 'no labels';
      }

      let label = name + ':' + language + ' not found';
      // @ts-ignore
      if (this.labels[name] && this.labels[name].languages) {
        // @ts-ignore
        if (this.labels[name].languages[language]) {
          // @ts-ignore
          label = this.labels[name].languages[language][word];
          // @ts-ignore
        } else if (this.labels[name].languages.nl) {
          // @ts-ignore
          label = this.labels[name].languages.nl[word];
        }
      }
      return label;
    }

    /**
     * getLabelTextWithPlaceholder !!! Usage of getLabelPlaceholder() is preferred!!!
     * @param {String} label - we assume that the label is already retrieved for example by getLabelText() or
     *                          getPlural()
     * @param {Object} placeholderData - This object contains the values which will replace the label placeholders.
     * @param {RegExp} [regex] - regular expression
     * @example Labels.getLabelTextWithPlaceholder('dit is een {name}, gebouwd met een nieuwe {description}',
     *                                              {name: 'myName', description: 'myDescription'});
     *  @returns {String}
     */
    getLabelTextWithPlaceholder (label, placeholderData, regex = /{([^{]*?)}/g) {
      return label.replace(regex, this.fetchPlaceholderText(placeholderData));
    }

    /**
     * fetchPlaceholderText
     * Function uses the custom data to replace the placeholders found in a label
     * @param {Object} placeholderData - Object which contains the custom data
     *
     */
    fetchPlaceholderText (placeholderData) {
      return function (regexMatch, matchedSubstring) {
        return placeholderData[matchedSubstring] || '';
      };
    }

    getLabelLowerCase (name) {
      return this.getLabelText(name, 'label').toLowerCase();
    }

    getLabelUpperCase (name) {
      return this.getLabelText(name, 'label').toUpperCase();
    }

    getLabelCapFirstLetter (name) {
      return this.capitalizeFirstLetter(this.getLabelText(name, 'label'));
    }

    getLabel (name) {
      return this.capitalizeFirstLetter(this.getLabelText(name, 'label'));
    }

    /**
     * getLabelPlaceholder
     * @param {String} name - key in labels.json
     * @param {Object} placeholderObject - This object contains the values which will replace the label placeholders.
     * @example Labels.getLabelPlaceholder('mynamedescription', {name: 'myName', description: 'myDescription'});
     * @returns {String}
     */
    getLabelPlaceholder (name, placeholderObject) {
      // We're still using the same getLabelText() to render labels
      const labelName = this.getLabelText(name);
      return this.capitalizeFirstLetter(this.getLabelTextWithPlaceholder(labelName, placeholderObject));
    }

    getLabelPlaceholderLowerCase (name, placeholderObject) {
      const labelName = this.getLabelText(name).toLowerCase();
      return this.getLabelTextWithPlaceholder(labelName, placeholderObject);
    }

    getPluralLowerCase (name) {
      return this.getLabelText(name, 'plural').toLowerCase();
    }

    getPluralUpperCase (name) {
      return this.getLabelText(name, 'plural').toUpperCase();
    }

    getPluralCapFirstLetter (name) {
      return this.capitalizeFirstLetter(this.getLabelText(name, 'plural'));
    }

    getPlural (name) {
      return this.capitalizeFirstLetter(this.getLabelText(name, 'plural'));
    }

    capitalizeFirstLetter (label) {
      return label.charAt(0).toUpperCase() + label.slice(1);
    }
  }

  exports.TranslateHelpers = TranslateHelpers;
})();
